import { AfterViewInit, Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { TaskType } from '@ee/common/enums';
import { User } from '@ee/common/models';

@Component({
  selector: 'ee-task-form',
  template: `
    <div [formGroup]="taskForm" class="flex flex-col justify-start items-stretch mt-1">
      <mat-form-field class="task-name compact mb-4 white" appearance="outline">
        <mat-label>{{ taskForm.get('type').value === TaskType.COURT ? 'Name' : 'Task Name' }}</mat-label>
        <input matInput formControlName="name" />
        <mat-hint>
          {{ !taskForm.get('name').hasValidator(Validators.required) ? 'Optional.' : 'Required.' }}
        </mat-hint>
        @if (taskForm.get('name').hasError('required')) {
          <mat-error>A Name is required</mat-error>
        }
      </mat-form-field>
      @if (!hideDescription) {
        <mat-form-field class="task-description compact mb-4 white" appearance="outline">
          <mat-label>Description</mat-label>
          <textarea
            #description
            matInput
            formControlName="description"
            (keyup)="textAreaAdjust()"
            class="overflow-hidden"
            cols="5"></textarea>
          <mat-hint>Optional</mat-hint>
        </mat-form-field>
      }
      @if (taskForm.get('type').value !== TaskType.COURT && !hideUserSelection) {
        <ee-user-selector
          class="mb-4"
          appearance="outline"
          placeholder="Assigned Users"
          [appendTo]="userSelectorAppendTo"
          [userSuggestions]="userSuggestions"
          [selectedUsers]="$any(taskForm.get('assigned_users'))"></ee-user-selector>
      }
      @if (!hideTaskScheduler) {
        <ee-task-schedule
          class="mb-4"
          [taskType]="taskForm.get('type').value"
          [dueDateControl]="$any(taskForm.get('due_date'))"
          [showTimeControl]="$any(taskForm.get('show_time'))"></ee-task-schedule>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TaskFormComponent implements AfterViewInit {
  @Input({ required: true })
    taskForm: FormGroup;
  @Input({ required: false })
    hideDescription = false;
  @Input({ required: false })
    hideUserSelection = false;
  @Input({ required: false })
    hideTaskScheduler = false;
  /**
   * CSS selector the assigned-users dropdown panel is appended to (passed through to
   * `ee-user-selector`). Defaults to `body`. When this form is hosted in a Material dialog, pass
   * `null` so the panel renders inline inside the modal (directly under the input) instead of behind
   * the dialog.
   */
  @Input({ required: false })
    userSelectorAppendTo: string | null = 'body';
  @Input({ required: false })
    dynamicDescriptionHeight = false;
  @Input({ required: true })
    userSuggestions: User[] = [];
  protected readonly Validators = Validators;
  protected readonly TaskType = TaskType;

  @ViewChild('description') description: ElementRef;

  ngAfterViewInit() {
    if (this.description) {
      this.textAreaAdjust();
    }
  }

  textAreaAdjust() {
    if (this.dynamicDescriptionHeight) {
      this.description.nativeElement.style.height = '1px';
      this.description.nativeElement.style.height = 25 + this.description.nativeElement.scrollHeight + 'px';
    }
  }
}
